import inputData from './inputData/lead-capture-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'lead-capture-form',
  title: 'Lead Capture Form',
  description: 'Engage visitors and turn them into qualified leads with a simple, high-converting form.',
  image: '/images/templates/lead-capture-form.png',
  tags: ['lead-generation', 'sales', 'make-sales'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

